import { IApplicationState } from '../../types/redux';

export const selectBuilderOffices = (state: IApplicationState) => {
  return state.builderCard.showAreas || [];
};
